export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const SHOW_SUCCESS_SNACKBAR = "SHOW_SUCCESS_SNACKBAR";
export const SHOW_GENERIC_SNACKBAR = "SHOW_GENERIC_SNACKBAR";
export const RESET_SNACKBAR_MESSAGE = "RESET_SNACKBAR_MESSAGE";
